export default function InventoryPlaceholderScreen() {
  return (
    <div className="rounded-2xl border border-[#EBEBEB] bg-white p-8 text-sm text-[#555555] shadow-[0_1px_4px_rgba(0,0,0,.06)]">
      <h2 className="text-lg font-semibold text-[#111111]">Inventory</h2>
      <p className="mt-2">Inventory management will be available here.</p>
    </div>
  );
}
